<template>
  <v-menu v-model="menu" :close-on-content-click="false" location="bottom">
    <template v-slot:activator="{ props }">
      <button class="no-overflow" variant="text" v-bind="props" color="#237276">
        <div class="d-flex ga-2 align-center">
          <img
            class="circle-img"
            :src="currentAvatar"
            alt="User Avatar"
            @error="onAvatarError"
          />
          <div class="d-flex flex-column">
            <p class="user-name-dropdown">{{ user.name }}</p>
            <span class="user-email-dropdown">{{ user.email }}</span>
          </div>
        </div>
      </button>
    </template>

    <v-card min-width="300">
      <v-list>
        <v-list-item
          to="/my-account"
          :prepend-avatar="currentAvatar"
          :subtitle="user.email"
          :title="user.name"
        />
      </v-list>

      <v-divider />

      <v-list>
        <v-list-item @click="loginForm?.logout">
          <span class="logout-text" >
            {{ $t("Logout") }}
          </span>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { loginForm } from "@/store/logIn";
import defaultAvatar from "@/assets/images/default.png";

export default {
  data: () => ({
    menu: false,
    loginForm: loginForm(),
    defaultAvatar,
    fallbackTriggered: false,
  }),
  computed: {
    user() {
      const c = JSON.parse(localStorage.getItem("user"));
      return c?.data || {};
    },
    currentAvatar() {
      // لو حصل fallback، استخدم الصورة الافتراضية
      return this.fallbackTriggered || !this.user.image
        ? this.defaultAvatar
        : this.user.image;
    },
  },
  methods: {
    onAvatarError() {
      this.fallbackTriggered = true;
    },
  },
};
</script>

<style scoped>
.logout-text {
  color: red;
  cursor: pointer;
}

.user-name-dropdown {
  text-align: start;
  line-height: 22.4px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.user-email-dropdown {
  text-align: start;
  font-weight: 400;
  font-size: 12px;
  line-height: 16.8px;
  color: rgba(102, 102, 102, 1);
}

.circle-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
